<template>
  <div>
  <v-row>
    <v-col cols="12" sm="10" md="5" lg="5" class="pb-0">
      <h1 class="pa-0 mb-10">SIP пароль и статистика</h1>

      <!-- получения SIP пароля -->
      <v-card class="mb-6" style="border-radius: 16px;">
        <v-card-title class="pb-2 d-flex align-center flex-nowrap">
          <span class="text-h6">Получение SIP пароля</span>
          <v-spacer />
          <v-tooltip v-if="roleName === 'admin'" bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="primary"
                class="flex-shrink-0"
                aria-label="История получения SIP пароля"
                v-bind="attrs"
                v-on="on"
                @click="openSipPasswordHistoryDialog"
              >
                <v-icon dense>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <span>История получения SIP пароля</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" lazy-validation @submit.prevent="validate">
            <v-row>
              <p class="ml-4">
                sip логин квартиры можно узнать из таблицы <v-icon small> mdi-arrow-right-bold-circle-outline</v-icon>
              </p>
              <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
                <v-text-field
                  flat
                  label="Sip квартиры"
                  outlined
                  prepend-inner-icon="mdi-home-account"
                  v-model="apartment"
                  dense
                  type="string"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
                <v-text-field
                  v-model="sipPasswordReason"
                  label="Комментарий"
                  outlined
                  dense
                  hint="Важно указать причину запроса, кто запросил, комментарий"
                  persistent-hint
                  prepend-inner-icon="mdi-comment-text-outline"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <div class="my-2 mt-4">
                <v-btn
                  large
                  color="success"
                  class="text-none"
                  dark
                  type="submit"
                >
                  Получить пароль
                </v-btn>
                <v-btn
                  large
                  class="ma-2 text-none"
                  outlined
                  dense
                  hide-details
                  color="error"
                  type="button"
                  @click="cancelPassword()"
                >
                  Очистить
                </v-btn>
              </div>
            </v-card-actions>
            <div v-if="isDisplayPassword" class="mt-4">
              <v-card style="border-radius: 16px;" class="pa-8">
                <p>
                  sip пароль от квартиры: {{ sipPassword }}
                  <v-icon
                    small
                    class="ml-2"
                    @click="copyToClipboard(sipPassword)"
                  >
                    mdi-content-copy
                  </v-icon>
                </p>
              </v-card>
            </div>
          </v-form>
        </v-card-text>
      </v-card>

      <!-- Форма получения статистики -->
      <v-card class="mb-6" style="border-radius: 16px;">
        <v-card-title class="pb-4">
          <span class="text-h6">Активированные устройства</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="validStatistics" lazy-validation @submit.prevent="validateStatistics">
            <v-row>
              <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
                <v-text-field
                  flat
                  label="SIP логин"
                  outlined
                  prepend-inner-icon="mdi-account"
                  v-model="statisticsLogin"
                  dense
                  type="string"
                  clearable
                  :rules="[v => !!v || 'Укажите SIP логин']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
                <v-text-field
                  flat
                  label="Период (дни)"
                  outlined
                  prepend-inner-icon="mdi-calendar-range"
                  v-model.number="period"
                  dense
                  type="number"
                  min="1"
                  max="365"
                  hint="От 1 до 365 дней"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
                <v-checkbox
                  v-model="displayToken"
                  label="Отображать токен"
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-card-actions>
              <div class="my-2 mt-4">
                <v-btn
                  large
                  color="success"
                  class="text-none"
                  dark
                  type="submit"
                  :loading="loadingStatistics"
                >
                  Получить статистику
                </v-btn>
                <v-btn
                  large
                  class="ma-2 text-none"
                  outlined
                  dense
                  hide-details
                  color="error"
                  type="button"
                  @click="cancelStatistics()"
                >
                  Очистить
                </v-btn>
              </div>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="pb-0">
      <v-card>
        <v-card-title>
          <span>Домофоны</span>
          <v-col cols="8" sm="7" md="7" lg="4">
            <v-text-field
              v-model="filterAddress"
              @keyup="validateKeyUp"
              prepend-inner-icon="mdi-magnify"
              autocomplete="chrome-off"
              hide-details
              label="Поиск по адресу или id"
              dense
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="7" md="7" lg="4">
            <v-autocomplete
              label="Управляющая компания"
              v-model="filterManagementCompany"
              :items="managementCompanies"
              item-text="name"
              item-value="id"
              style="max-width: 280px"
              prepend-inner-icon="mdi-home-account"
              class="pl-3 shrink mb-1"
              dense
              clearable
              hide-details
            >
            </v-autocomplete>
          </v-col>
          <v-btn
            dark
            class="btn blue darken-3 white px-7 text-none"
            @click.prevent="filterDoorphones"
          >
            Поиск
          </v-btn>
        </v-card-title>
        <v-data-table
          class="table"
          v-model="selectedDoorphones"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :headers="headersDoorphones"
          :items="doorphones"
          item-key="id"
          show-select
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
             showFirstLastPage: true,
          }"
          :single-select="true"
          :disable-sort="true"
        >
          <template v-slot:item.address="{ item }">
            <router-link class="routerLink" :to="`/doorphones/${item.id}`">
              {{ item.address }}
            </router-link>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#1E6CEB"
                  class="text-none"
                  dense
                  v-bind="attrs"
                  style="cursor: auto;"
                  v-on="on"
                  dark
                  icon
                  right
                  @click="showListApartments(item.id)"
                >
                  <v-icon>
                    mdi-arrow-right-bold-circle-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Список квартир</span>
            </v-tooltip>
            <v-dialog v-model="dialogListApartments[item.id]" max-width="800">
              <list-apartments
                :active.sync="dialogListApartments[item.id]"
                :is-active="dialogListApartments"
                :doorphone="item"
                :list-apartments="rules"
                @close="$set(dialogListApartments, item.id, false)"
              />
            </v-dialog>
          </template>
          <template v-slot:item.sip_status="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#1E6CEB"
                    class="text-none"
                    dense
                    v-bind="attrs"
                    style="cursor: auto;"
                    v-on="on"
                    dark
                    icon
                    right
                  >
                    <v-icon x-small :color="item.sip_status_color">
                      mdi-checkbox-blank-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.sip_status_text }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>

  <v-row v-if="statistics || statisticsError" id="statistics-section" ref="statisticsRow" class="mt-4 statistics-full-width">
    <v-col cols="12" class="pa-0">
      <sip-cache-statistics
        v-if="statistics"
        :statistics="statistics"
      />
      <v-alert
        v-if="statisticsError"
        type="error"
        outlined
        class="mt-4"
      >
        {{ statisticsError }}
      </v-alert>
    </v-col>
  </v-row>

  <v-row class="mt-4">
    <v-col cols="12" sm="10" md="5" lg="5" class="pb-0">
      <v-card style="border-radius: 16px;" class="mb-6">
        <v-card-title class="pb-2">
          <span class="text-h6">Выгрузка плана набора с sip_settings домофона</span>
        </v-card-title>
        <v-card-text>
          <unloading-sip-settings-doorphone
            :doorphone="selectedDoorphones"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

    <v-dialog
      v-model="sipPasswordHistoryDialog"
      max-width="960"
      scrollable
      content-class="dialog-border-radius"
    >
      <v-card>
        <v-card-title class="text-h6">
          История получения SIP пароля
          <v-spacer />
          <v-btn icon small @click="sipPasswordHistoryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 pt-2">
          <v-data-table
            class="table"
            :headers="sipPasswordHistoryHeaders"
            :items="sipPasswordHistoryRows"
            :loading="sipPasswordHistoryLoading"
            :footer-props="{
              'items-per-page-options': [10, 15, 25, 50],
              showFirstLastPage: true,
            }"
          >
            <template #item.created_at="{ item }">
              {{ ruDateFormat(item.created_at) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListApartments from './components/ListApartments';
import UnloadingSipSettingsDoorphone from '@/components/adminSettings/UnloadingSipSettingsDoorphone';
import SipCacheStatistics from './components/SipCacheStatistics.vue';
import Doorphone from '@/services/api/doorphone';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'SipPasswordApartment',
  mixins: [ruDateFormatMixin],
  components: { UnloadingSipSettingsDoorphone, ListApartments, SipCacheStatistics },
  data: () => ({
    isCreated: false,
    dialogListApartments: {},
    paid: true,
    apartment: '',
    filterManagementCompany: '',
    isDisplayPassword: false,
    lastCopiedText: null,
    sipPassword: '',
    selectedDoorphones: [],
    totalDoorphones: 0,
    filterAddress: '',
    isLoading: {},
    rules: [],
    options: {
      itemsPerPage: 10,
    },
    valid: true,
    validStatistics: true,
    statisticsLogin: '',
    period: 7,
    displayToken: false,
    statistics: null,
    loadingStatistics: false,
    statisticsError: null,
    sipPasswordReason: '',
    sipPasswordHistoryDialog: false,
    sipPasswordHistoryLoading: false,
    sipPasswordHistoryRows: [],
    sipPasswordHistoryHeaders: [
      { text: 'SIP логин', value: 'sip_login', sortable: false },
      { text: 'Квартира', value: 'apartment', sortable: false },
      { text: 'Адрес', value: 'doorphone_address', sortable: false },
      { text: 'Комментарий', value: 'reason', sortable: false },
      { text: 'Дата', value: 'created_at', sortable: false },
      { text: 'Пользователь', value: 'userLine', sortable: false },
    ],
    filters: { status: '', type: 'A,M,G' },
    sort: '',
    headersDoorphones: [
      {
        text: 'id',
        value: 'id',
      },
      {
        text: 'Адрес',
        value: 'address',
      },
      {
        text: 'Диапазон',
        value: 'diapason',
      },
      {
        text: 'Агент',
        value: 'agent',
      },
      {
        text: 'Управляющая компания',
        value: 'management_company',
      },
      {
        text: 'Статус',
        value: 'sip_status',
      },
      {
        text: '',
        value: 'actions',
      },
    ],
  }),
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.isCreated = true;
    this.sort = ['-id'];
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
    }
    this.loadDoorphones();

    this.loadManagementCompanies({
      filters: { with_doorphones: 1 },
    });
  },
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/doorphones',
      managementCompanies: 'ManagementCompany/managementCompanies',
      roleName: 'roleName',
    }),
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getDoorphones',
      getSipSettings: 'Apartment/getSipSettings',
      getRules: 'Doorphone/getRules',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
      getSipCacheStatistics: 'Doorphone/getSipCacheStatistics',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    async copyToClipboard (value) {
      if (this.lastCopiedText === value) {
        return;
      }
      try {
        await navigator.clipboard.writeText(value);
        this.lastCopiedText = value;
        this.$flash_success('sip пароль скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать sip пароль');
      }
    },
    validate () {
      if (this.apartment === '') {
        this.$flash_danger('Укажите sip логин!');
        return;
      }
      const reason = (this.sipPasswordReason || '').trim();
      if (!reason) {
        this.$flash_danger('Укажите комментарий!');
        return;
      }
      this.getSip(this.apartment.trim(), reason);
    },
    cancelPassword () {
      this.apartment = '';
      this.sipPasswordReason = '';
      this.isDisplayPassword = false;
      this.sipPassword = '';
    },
    validateStatistics () {
      if (!this.statisticsLogin || this.statisticsLogin.trim() === '') {
        this.$flash_danger('Укажите SIP логин!');
        return;
      }
      if (this.period && (this.period < 1 || this.period > 365)) {
        this.$flash_danger('Период должен быть от 1 до 365 дней!');
        return;
      }
      this.fetchStatistics();
    },
    cancelStatistics () {
      this.statisticsLogin = '';
      this.period = 7;
      this.displayToken = false;
      this.statistics = null;
      this.statisticsError = null;
    },
    async fetchStatistics () {
      this.loadingStatistics = true;
      this.statisticsError = null;
      this.statistics = null;

      const params = {
        login: this.statisticsLogin.trim(),
      };

      if (this.period) {
        params.period = this.period;
      }

      params.display_token = this.displayToken ? 1 : 0;

      try {
        const data = await this.getSipCacheStatistics(params);
        this.statistics = data;
        this.$flash_success('Статистика успешно получена!');
        await this.$nextTick();
        await this.$nextTick();
        setTimeout(() => {
          const statisticsElement = document.getElementById('statistics-section');
          if (statisticsElement) {
            statisticsElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      } catch (e) {
        console.error(e);
        this.$sentry_exception(e);
        this.statisticsError = 'Произошла ошибка при получении статистики. Проверьте правильность SIP логина и попробуйте позже.';
        this.$flash_warning('Ошибка при получении статистики');
      } finally {
        this.loadingStatistics = false;
      }
    },
    loadDoorphones () {
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.totalDoorphones = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
        });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'A,M,G' };

      if (this.filterAddress) {
        if (!isNaN(this.filterAddress)) {
          this.filters.id = this.filterAddress;
          delete this.filters.address;
        } else {
          this.filters.address = this.filterAddress;
          delete this.filters.id;
        }
      }
      if (this.filterManagementCompany) {
        this.filters.management_company_id = this.filterManagementCompany;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    async showListApartments (id) {
      await this.getRules(id)
        .then((data) => {
          this.dialogListApartments[id] = true;
          this.rules = data.rules.data;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке квартир');
          }
        });
    },
    getSip (login, reason) {
      this.getSipSettings({ login, reason })
        .then((data) => {
          this.isDisplayPassword = true;
          this.sipPassword = data.sip_password;
          this.$flash_success('Sip пороль успешно получен!');
        })
        .catch((e) => {
          console.error(e);
          this.$sentry_exception(e);
          this.$flash_warning('Произошла ошибка, возможно домофон не в сети, попробуйте позже.');
        });
    },
    mapSipPasswordHistoryRow (entry) {
      const action = entry && entry.action !== undefined ? entry.action : entry;
      const data = action.data || {};
      const u = action.user && action.user.user ? action.user.user : action.user;
      let userLine = '—';
      if (u && typeof u === 'object') {
        const name = u.name || '';
        const email = u.email || '';
        userLine = [name, email].filter(Boolean).join(' · ') || '—';
      }
      return {
        id: action.id,
        created_at: action.created_at || action.updated_at || '',
        sip_login: data.sip_login != null ? String(data.sip_login) : '—',
        apartment: data.apartment != null ? data.apartment : '—',
        reason: data.reason != null && data.reason !== '' ? String(data.reason) : '—',
        userLine,
        doorphone_address:
          (action.doorphone && action.doorphone.address) ||
          (action.doorphone_summary && action.doorphone_summary.address) ||
          (action.doorphone && action.doorphone.doorphone && action.doorphone.doorphone.address) ||
          '—',
      };
    },
    openSipPasswordHistoryDialog () {
      this.sipPasswordHistoryDialog = true;
      this.loadSipPasswordHistory();
    },
    loadSipPasswordHistory () {
      this.sipPasswordHistoryLoading = true;
      Doorphone.getApartmentSipPasswordRequestsHistory({
        page: 1,
        limit: 500,
      })
        .then((payload) => {
          const list = payload && Array.isArray(payload.data) ? payload.data : [];
          this.sipPasswordHistoryRows = list.map((item) => this.mapSipPasswordHistoryRow(item));
        })
        .catch((e) => {
          console.error(e);
          this.$sentry_exception(e);
          this.$flash_warning('Не удалось загрузить историю получения SIP пароля');
          this.sipPasswordHistoryRows = [];
        })
        .finally(() => {
          this.sipPasswordHistoryLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

.statistics-full-width {
  margin-left: -20px !important;
  margin-right: -20px !important;
  width: calc(100% + 40px) !important;
  max-width: calc(100% + 40px) !important;
}
</style>
